import { VesselData, VesselModel } from 'models/VesselModel';
import { ApiBase } from 'utils/api';
import { objectToFormData } from 'utils/common';


export default class VesselApi {
    private base: ApiBase;

    constructor(base: ApiBase) {
        this.base = base;
    }

    all = () => {
        return this.base.axios.get(`/api/vessels`);
    };

    create = (data: VesselData) => {
        return this.base.axios.post(`/api/vessels`, objectToFormData(data), {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
    };

    // post with _method=PUT because bug in symphony with empty $request->all() on PUT form-data
    update = (data: VesselModel) => {
        return this.base.axios.post(`/api/vessels/${data.id}?_method=PUT`,
            objectToFormData(data),
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }
        );
    };

    delete = (id: number) => {
        return this.base.axios.delete(`/api/vessels/${id}`);
    };
}
